import React from 'react';
import { CheckIcon, MessageSquareIcon, PhoneIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { ButtonLink } from './ButtonLink';
import { business, engines } from '../data/site';
export function Engines() {
  return <section id="engines" aria-labelledby="engines-title" className="gutter section-y w-full scroll-mt-24 bg-white" data-id="element-110" data-mp="37591z4msewa0">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-111" data-mp="3c6ewn800ctm6">
        <h2 id="engines-title" className="display text-[clamp(2.75rem,5.5vw,6rem)] font-extrabold text-navy" data-id="element-112" data-mp="2xdl4on3jul0m">
          Outboards In Stock
        </h2>
        <p className="max-w-[44ch] text-ink-muted md:text-right" data-id="element-113" data-mp="2ofsolgq079c6">
          Ready to rig. Call or text for current pricing and availability.
        </p>
      </div>

      <div className="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-3 3xl:gap-10" data-id="element-114" data-mp="2tbq8fx0h6xtp">
        {engines.map((e, i) => <Reveal key={e.model} delay={i * 0.05} className="h-full" data-id="element-115" data-mp="2jfn18cqro8zw" data-mpi={i}>
            <article className="flex h-full flex-col overflow-hidden rounded-xl border border-navy/10 bg-white" data-id="element-116" data-mp="2ji106woki5cq">
              <div className="relative aspect-[4/3] bg-sand-50" data-id="element-117" data-mp="11m126gcbiejc">
                <img src={e.image} alt={e.alt} loading="lazy" className="h-full w-full object-cover" data-id="element-118" data-mp="11lspopk3xb8o" />
                <span className="absolute left-4 top-4 rounded bg-navy px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-white" data-id="element-119" data-mp="1fl0r7p3qsvg1">
                  {e.brand}
                </span>
                <span className="display absolute bottom-3 right-4 text-5xl font-extrabold text-navy/90" data-id="element-120" data-mp="nv5p0rusdb9y">{e.hp}</span>
              </div>
              <div className="flex flex-1 flex-col p-6 md:p-7" data-id="element-121" data-mp="wmxvysklq29s">
                <div className="flex items-baseline justify-between gap-4" data-id="element-122" data-mp="woiusudy87dg">
                  <h3 className="display text-3xl font-bold text-navy" data-id="element-123" data-mp="rv6er8nc58wb">
                    {e.brand} {e.model}
                  </h3>
                  <span className="shrink-0 text-sm font-semibold text-ink-soft" data-id="element-124" data-mp="44k8nmww5yoy">{e.shaft}</span>
                </div>
                <p className="mt-2 text-ink-muted" data-id="element-125" data-mp="1z9tdd1usx2hu">{e.summary}</p>
                <ul className="mt-5 space-y-2 border-t border-navy/10 pt-5" data-id="element-126" data-mp="1z9a387be7ied">
                  {e.specs.map(s => <li key={s} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-127" data-mp="246jrhjn1po0m">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-water-600" aria-hidden="true" data-id="element-128" data-mp="291pnjba5wj2f" />
                      {s}
                    </li>)}
                </ul>
                <div className="mt-auto grid gap-2 pt-7" data-id="element-129" data-mp="1gcs8dh18z2dw">
                  <ButtonLink href={business.tel} ariaLabel={`Call for price on the ${e.brand} ${e.model}`} data-id="element-130" data-mp="1l98wib8g5gqz">
                    <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-131" data-mp="1q8bzlq4v9cwb" />
                    Call or Text for Price
                  </ButtonLink>
                  <ButtonLink href={`${business.sms}?&body=${encodeURIComponent(`Hi, I'm asking about the ${e.brand} ${e.model} (${e.shaft}).`)}`} variant="outline" ariaLabel={`Ask about this motor: ${e.brand} ${e.model}`} data-id="element-132" data-mp="1v5vf0tdavvpu">
                    <MessageSquareIcon className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="q0yil5u8ar1x" />
                    Ask About This Motor
                  </ButtonLink>
                </div>
              </div>
            </article>
          </Reveal>)}
      </div>

      <p className="mt-10 text-lg text-ink" data-id="element-134" data-mp="gacadwoud2t9">
        <strong className="font-semibold" data-id="element-135" data-mp="bc2chebqfo3y">Don’t see your motor?</strong>{' '}
        <span className="text-ink-muted" data-id="element-136" data-mp="bdddj6dsmhrd">Most other Yamaha and Honda models are available within 2–4 days.</span>{' '}
        <a href="#contact" className="font-semibold text-navy underline underline-offset-4 hover:text-water-600" data-id="element-137" data-mp="7ctgs3x4tg5r">
          Ask us
        </a>
      </p>
    </section>;
}